import { ContractPageContent } from '../../ContractsPageContent';
import { ShowLoading } from 'src/shared/components/ShowLoading';
import { ShowError } from 'src/shared/components/ShowError';
import Grid2 from '@mui/material/Unstable_Grid2';
import { Box } from '@mui/material';
import { FlexflowContractsListActions } from '../../FlexflowContractListActions';
import Subtitle from '../../Subtitle';
import { useTab2 } from './hooks';

export const Tab2 = () => {
  const {
    setFilterValues,
    filterScheme,
    filterValues,
    handleChangePage,
    handleChangeRowsPerPage,
    page,
    rowsPerPage,
    data,
    isLoading,
    isError,
    error
  } = useTab2();

  if (isLoading) {
    return <ShowLoading />;
  }

  if (isError || !data) {
    return <ShowError error={error} />;
  }
  return (
    <>
      <Grid2 container xs={12} justifyContent="space-between" mb={2}>
        <Box mb={4}>
          <Subtitle descriptionI18Key="tab 2 description" />
        </Box>
        <FlexflowContractsListActions
          filterValues={filterValues}
          filterScheme={filterScheme}
          setFilterValues={setFilterValues}
          handleChangePage={handleChangePage}
          data={data}
          resetFilters={() => {}}
        />
      </Grid2>
      <ContractPageContent
        isRequestedAndActiveTab
        data={data}
        page={page}
        handleChangePage={handleChangePage}
        handleChangeRowsPerPage={handleChangeRowsPerPage}
        rowsPerPage={rowsPerPage}
      />
    </>
  );
};
